import { IShapes } from '../interfaces/index';

export const AI_MODES_IDX = {
  VISION: 0,
  CLASSIFY: -1,
  SEARCH: 1,
  FILTER: 2,
};

//export const AI_MODES = ['Vision', 'Classify', 'Search', 'Filter'];
export const AI_MODES = ['Vision', 'Search', 'Filter'];

export const SHAPES: IShapes = {
  DRAW: 0,
  SQUARE: 1,
  CIRCLE: 2,
  ARROW: 3,
};

export const timezones = [
  'America/Vancouver',
  'America/Edmonton',
  'America/Winnipeg',
  'America/Toronto',
  'America/Halifax',
  'America/St_Johns',
];

export const taskListMap = [
  {
    code: 'RfR',
    action: 'Request for Reconsideration',
  },
  {
    code: 'RSR',
    action: 'Residential Sales Review',
  },
  {
    code: 'FSR',
    action: 'Farm Sales Review',
  },
  {
    code: 'DSR',
    action: 'Sales Review',
  },
  {
    code: 'TA',
    action: 'Tax Application',
  },
  {
    code: 'BP',
    action: 'Building Permit',
  },
];
